export default {
  ADD_NOTICE(state, notice) {
    state.notices.unshift(notice)
  },
  SET_NOTICES(state, notices) {
    state.notices = notices
  },
  UPDATE_NOTICE(state, notice) {
    const noticeIndex = state.notices.findIndex(e => e.id === notice.id)
    Object.assign(state.notices[noticeIndex], notice)
  },
  REMOVE_NOTICE(state, noticeId) {
    const noticeIndex = state.notices.findIndex(e => e.id === noticeId)
    state.notices.splice(noticeIndex, 1)
  },
  SET_NOTICES_COUNT(state, count) {
    state.noticesCount = count
  },
  SET_NOTICES_QUERY(state, query) {
    state.query = query
  },
  SET_NOTICES_LIMIT(state, limit) {
    state.limit = limit
  },
  SET_NOTICES_SKIP(state, skip) {
    state.skip = skip
  }
}
